import React, { useState, useEffect } from "react";
import { Avatar, CircularProgress } from "@mui/material";
import Axios from "axios";
import { useNavigate } from "react-router-dom";

const badgeStyle = (bg, color) => ({
  fontFamily: "Nunito",
  fontSize: 11,
  fontWeight: 700,
  color,
  background: bg,
  borderRadius: 20,
  padding: "3px 10px",
  whiteSpace: "nowrap",
});

const AllInvestors = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    Axios({ method: "GET", url: "/api/admin/all-investors" })
      .then((res) => setData(Array.isArray(res.data?.allInvestors) ? res.data.allInvestors : []))
      .catch((err) => {
        setError(err?.response?.data?.message || err.message || "Failed to load investors");
        setData([]);
      });
  }, []);

  return (
    <div style={{ padding: "36px 40px", maxWidth: 1200, margin: "0 auto", boxSizing: "border-box" }}>
      <div style={{ marginBottom: 32 }}>
        <h1 style={{ fontFamily: "Nunito", fontWeight: 800, fontSize: 40, color: "#111827", margin: 0 }}>
          All Investors
        </h1>
        <p style={{ fontFamily: "Nunito", fontSize: 14, color: "#6b7280", margin: "6px 0 0" }}>
          {data === null
            ? "Loading…"
            : `${data.length} investor${data.length !== 1 ? "s" : ""} in the database`}
        </p>
      </div>

      {data === null ? (
        <div style={{ display: "flex", justifyContent: "center", padding: 60 }}>
          <CircularProgress />
        </div>
      ) : error ? (
        <p style={{ fontFamily: "Nunito", color: "#dc2626", fontSize: 15 }}>{error}</p>
      ) : data.length === 0 ? (
        <p style={{ fontFamily: "Nunito", color: "#9ca3af", fontSize: 15 }}>No investors found.</p>
      ) : (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 12 }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#f8fafc" }}>
                {["Investor", "Email", "Country", "Company", "Status", "Spam Reports"].map((h) => (
                  <th
                    key={h}
                    style={{
                      textAlign: "left",
                      padding: "14px 16px",
                      borderBottom: "1px solid #e2e8f0",
                      fontSize: 13,
                      color: "#475569",
                      whiteSpace: "nowrap",
                      fontFamily: "Nunito",
                    }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((investor, i) => {
                const user = investor?.user || {};
                const userId = investor?.id;
                const fullName =
                  investor?.name ||
                  `${user.firstname || ""} ${user.lastname || ""}`.trim() ||
                  "--";
                const spamCount = investor?.spamReportCount || 0;

                return (
                  <tr
                    key={userId || investor?._id || i}
                    onClick={() => userId && navigate(`/admin/user-activity?tab=13&userid=${userId}`)}
                    style={{ cursor: userId ? "pointer" : "default" }}
                  >
                    <td style={{ padding: "12px 16px", borderBottom: "1px solid #f1f5f9" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <Avatar src={user.avatar} style={{ width: 36, height: 36 }} />
                        <span style={{ fontFamily: "Nunito", fontWeight: 700, fontSize: 14, color: "#111827" }}>
                          {fullName}
                        </span>
                      </div>
                    </td>
                    <td style={{ padding: "12px 16px", borderBottom: "1px solid #f1f5f9", fontFamily: "Nunito", fontSize: 13, color: "#374151" }}>
                      {user.email || investor?.contact?.email || "--"}
                    </td>
                    <td style={{ padding: "12px 16px", borderBottom: "1px solid #f1f5f9", fontFamily: "Nunito", fontSize: 13, color: "#374151" }}>
                      {investor?.location?.country || "--"}
                    </td>
                    <td style={{ padding: "12px 16px", borderBottom: "1px solid #f1f5f9", fontFamily: "Nunito", fontSize: 13, color: "#374151" }}>
                      {investor?.currentCompany || "--"}
                    </td>
                    <td style={{ padding: "12px 16px", borderBottom: "1px solid #f1f5f9" }}>
                      <span style={badgeStyle(investor?.isVerified ? "#dcfce7" : "#fef3c7", investor?.isVerified ? "#166534" : "#92400e")}>
                        {investor?.isVerified ? "Verified" : "Pending"}
                      </span>
                      {user.isBlocked && (
                        <span style={{ ...badgeStyle("#fee2e2", "#991b1b"), marginLeft: 6 }}>Blocked</span>
                      )}
                    </td>
                    <td style={{ padding: "12px 16px", borderBottom: "1px solid #f1f5f9" }}>
                      <span style={badgeStyle(spamCount > 0 ? "#fee2e2" : "#f3f4f6", spamCount > 0 ? "#991b1b" : "#374151")}>
                        {spamCount > 0 ? `${spamCount} marked as spam` : "0"}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AllInvestors;
